import React from 'react'
import { getImages } from '../../Common/const'
import { Link } from 'react-router-dom'

const ServiceCenter = () => {
  return (
    <>
        <section className='service-center-wrap d-lg-flex align-items-center'>
            <div className='sc-left wow reveal fadeInLeft'>
                <img src={getImages('angle-img.png')} alt='angle'/>
            </div>
            <div className='sc-right'>
                <div className='scr-block wow reveal fadeInRight'>
                    <h3 className='lg-title mb-3'>Service Center</h3>
                    <p>European Exotic Center’s roots are in servicing a wide range of exotic and collectible cars. Our 8,500 sq/ft shop is staffed by multiple Master Technicians, each with decades of expertise. We have the tools, technology and experience to flawlessly execute your next vehicle service, while providing you with a great value.</p>
                    <div className='mt-md-4 mt-5'>
                        <Link to='/car-service-in-tampa-fl' state={{ openModal: true }} className='black-red-btn w-270 d-inline-block text-uppercase'>Schedule Service</Link>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default ServiceCenter